<ng-template #communicationGridModalForm role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="communicationFormCancel()"
  ></app-modal-comp-header>
  
  <div class="modal-body">
    <app-communications-embedded #communicationsEmbedded
      (gridAddClick)="gridAddButtonClick($event)"
      (gridEditClick)="gridEditButtonClick($event)"
    >
    </app-communications-embedded>
  </div>
  <div class="modal-footer">
    <div class="hstack gap-2 justify-content-end">
      <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="communicationFormCancel()">Close</button>
      <!-- <button type="submit" class="btn btn-success" id="add-btn">Submit</button> -->
    </div>
  </div>  
</ng-template>

<app-communication-modal-form #communicationModalForm
  (formCancelled)="communicationFormHasBeenCancelled()"
  (dataHasBeenSaved)="communicationDataHasBeenSaved($event)"
  (openReplyModal)="communicationFormOnOpenReply($event)"
></app-communication-modal-form>

<app-communication-modal-form #replyModalForm
></app-communication-modal-form>

@if (showComposeForm) {
  <app-communication-compose-modal-form #communicationComposeModalForm
    (formCancelled)="communicationFormHasBeenCancelled()"
    (dataHasBeenSaved)="communicationDataHasBeenSaved($event)"
  ></app-communication-compose-modal-form>
}
